module.exports = __webpack_public_path__ + "static/img/cart_wh.332f1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/cart_wh.png
// module id = BoLy
// module chunks = 10